import User from "models/user";

export const user = new User({});
